module.exports = __webpack_public_path__ + "static/media/mask.c780e5bd.png";